import * as React from "react";
import { IOpLabelValue } from "../../../../types/components/orderPlacement/opTypes";

export interface IOpQuotesTwoColDataProps {
	data: Array<IOpLabelValue>;
}

const OpQuotesTwoColData: React.FC<IOpQuotesTwoColDataProps> = props => {
	return (
		<div className="op_quote_two_col_data">
			{props.data.map(d => (
				<div className="col ib" key={d.label}>
					<div className="label">{d.label}</div>
					<div className="value">{d.value}</div>
				</div>
			))}
		</div>
	);
};

export default OpQuotesTwoColData;
